import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React from 'react'
import { Toast } from '../../../libs/app-core/Toast';
import { useGridApiRef } from '../../../libs/data-grid-view/useGridApiRef';
import { linear_content_style } from '../../../libs/linear-layout/LinearLayout';
import UcDgvCustomPagination from '../../components/UcDgvCustomPagination';
import UcDgvCustomToolbar from '../../components/UcDgvCustomToolbar';
import { SpwkMetaData } from '../../export_spwk/SpwkMetaData';
import { SpwkToHisInfo } from './SpwkToHisInfo';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import { useAppContext } from '../../../libs/app-core/AppContext';
import { DGV_LOCAL_TEXT } from '../../components/UIHelper';
import { UniFunc } from '../../dao/UniFunc';

type Props = {
  // /* 所有的轉檔資料列表 */
  // InfoList: SpwkToHisInfo[];

  // /* 此畫面要顯示哪個 Answer 的轉檔結果 */
  // SelectedAnswerGuid: string;

  /** 左側選單 Focus 的轉檔結果 */
  CurrInfo: SpwkToHisInfo | undefined;

  /* 篩選: 特作編號 (此轉檔結果，繼續篩選，只看到指定特作) */
  CurrUniFunc: UniFunc | null;

}

const UcSpwkMetaTableView = ({ CurrInfo, CurrUniFunc, ...props }: Props) => {

  const ctx = useAppContext();

  const columns: GridColDef<SpwkMetaData>[] = [
    {
      field: "func_code",
      headerName: "特作",
      width: 80,
      description: "特作代碼，代表同一份問卷",
    },
    { field: "chapter", headerName: "chapter", width: 120, description: "" },
    { field: "data_type", headerName: "type", width: 80, description: "" },
    { field: "kind", headerName: "kind", width: 80, description: "" },
    {
      field: "display_code",
      headerName: "display_code",
      width: 280,
      valueGetter: (params) => {
        const data = params.row as SpwkMetaData;
        return data.getDebugDisplayCode();
      },
    },
    { field: "is_need_value", type: "boolean", headerName: "需填", width: 80, editable: true, },

    { field: "rhf_name", headerName: "rhf_name", width: 480, description: "" },

    { field: "rhf_value", headerName: "rhf_value", width: 120, editable: true },

    { field: "q_his_rule", headerName: "q_his_rule", width: 120, editable: true },
    { field: "o_his_rule", headerName: "o_his_rule", width: 120, editable: true },
    { field: "i_his_rule", headerName: "i_his_rule", width: 120, editable: true },

    { field: "his_code", headerName: "his_code", width: 240, editable: true },
    { field: "q_gov_code", headerName: "q_gov_code", width: 120, editable: true },
    { field: "o_gov_code", headerName: "o_gov_code", width: 120, editable: true },
    { field: "i_gov_code", headerName: "i_gov_code", width: 120, editable: true },

    { field: "question_guid", headerName: "question_guid", width: 120, editable: true, },
    { field: "data_serno", headerName: "data_serno", width: 120, editable: true },
  ];

  const grid_api = useGridApiRef(columns);

  return (
    <div style={linear_content_style}>
      {render_DataGrid()}
    </div>
  );

  function render_DataGrid(): React.ReactNode {

    if (CurrInfo == null) {
      return <></>;
    }

    let data_list: SpwkMetaData[] = CurrInfo.ExportBundle?.AllMetaDataList ?? [];

    if (CurrUniFunc != null) {
      data_list = data_list.filter(x => x.func_code === CurrUniFunc.func_code);
    }

    return (
      <DataGrid
        style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
        rows={data_list}
        columns={grid_api.columns}

        localeText={DGV_LOCAL_TEXT}// 中文

        components={{
          Toolbar: () => {
            return (<UcDgvCustomToolbar>
              <IconButton onClick={() => { Toast.Show(ctx, "More") }} ><MoreVertIcon /></IconButton>
            </UcDgvCustomToolbar>);
          },
          Pagination: () => {
            return <UcDgvCustomPagination />
          },
        }}

        density={"compact"}
        pageSize={100}
        rowsPerPageOptions={[100]}
        hideFooterSelectedRowCount
        // hideFooter

        onCellEditCommit={async ({ id, field, value }) => { }}
      />
    );
  }
}

export default UcSpwkMetaTableView